import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=1a002b4c&scoped=true&"
import script from "./ContactsPage.vue?vue&type=script&lang=js&"
export * from "./ContactsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactsPage.vue?vue&type=style&index=0&id=1a002b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a002b4c",
  null
  
)

export default component.exports